module.exports = __webpack_public_path__ + "assets/1.d52a10ba.png";